import { SCOPE as PARENT_SCOPE } from '../types';
export const SCOPE = `${PARENT_SCOPE}.sensitivityControl`;
export const INIT = `${SCOPE}/INIT`;

export const FETCH_DATA = `${SCOPE}/FETCH_DATA`;
export const FETCHING = `${SCOPE}/FETCHING`;
export const SET_ERROR = `${SCOPE}/SET_ERROR`;
// Order, fetch, fetchlogs, saveInfo
export const SET_SENSITIVITY_METRIC_CONFIG_LIST = `${SCOPE}/SET_SENSITIVITY_METRIC_CONFIG_LIST`;
export const FETCH_SENSITIVITY_LOGS = `${SCOPE}/FETCH_SENSITIVITY_LOGS`;
export const SAVE_SENSITIVITY_DATA = `${SCOPE}/SAVE_SENSITIVITY_DATA`;

export const UPDATE_SELECTED_METRIC_SENSITIVITY_DATA = `${SCOPE}/UPDATE_SELECTED_METRIC_SENSITIVITY_DATA`;

export const SET_SELECTED_METRIC = `${SCOPE}/SET_SELECTED_METRIC`;
export const SET_SENSITIVITY_LOGS = `${SCOPE}/SET_SENSITIVITY_LOGS`;
export const SET_CURRENT_CONFIG = `${SCOPE}/SET_CURRENT_CONFIG`;
export const UPDATE_CURRENT_CONFIG = `${SCOPE}/UPDATE_CURRENT_CONFIG`;
export const SET_SENSITIVITY_CONFIG_ERROR_MSG = `${SCOPE}/SET_SENSITIVITY_CONFIG_ERROR_MSG`

export const SENSITIVITY_LOGS_FETCHING = `${SCOPE}/SENSITIVITY_LOGS_FETCHING`;
export const SET_LOGS_ERROR = `${SCOPE}/SET_LOGS_ERROR`;
